<div class="spacing-top justify-content-between">
	<div data-testid="SUBSYS7_INSPOINTWK_BACK_BTN" class="wrapper-back" (click)="back()" (keypress)="back()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ labels().INS_POINT_WORKFLOW_COMPONENT_CANCEL_BTN }}</span>
	</div>
	<span data-testid="SUBSYS7_INSPOINTWK_CANCEL_BTN" class="material-icons md-18 back me-4" (click)="cancel()"
		(keypress)="cancel()">close</span>
</div>

<div class="main-step">
	<div class="box-menu-settings active">
		<div class="row-box">
			<h4>{{ labels().INS_POINT_WORKFLOW_COMPONENT_TITLE }}</h4>
		</div>
		<div class="row-box">
			<div class="box-suggestion">
				<p>{{ labels().INS_POINT_WORKFLOW_COMPONENT_MESSAGE }}</p>
			</div>
		</div>
		<div class="row-box wrapper-img-axis justify-content-center">
			<div class="" [hidden]="!isImgAPVisible">
				<img [src]="helpImgAP" alt="" (load)='isImgAPVisible = true' style="height: 25rem;">
			</div>
		</div>
		@if (hasLT) {
		<div class="row-box wrapper-img-axis justify-content-center">
			<div class="" [hidden]="!isImgLTVisible">
				<img [src]="helpImgLT" alt="" (load)='isImgLTVisible = true' style="height: 25rem;">
			</div>
		</div>
		}
		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS7_INSPOINTWK_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					[disabled]="false" (click)="confirm()">
					{{ labels().INS_POINT_WORKFLOW_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>
	</div>
</div>